<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
</svg>
